import {FormControl, FormField} from 'platform/components';

import {i18n} from '@dms/i18n';
import {useTenant} from '@dms/shared';

import {PurchasePriceRuleFormValues} from '../schemas/PurchasePriceRuleFormSchema';
import {PurchasePriceRuleFormSection} from './PurchasePriceRuleFormSection';

interface PurchasePriceRuleWarrantySectionProps {
  control: FormControl<PurchasePriceRuleFormValues>;
  baseTestId: (suffix: string) => string;
}

export function PurchasePriceRuleWarrantySection(props: PurchasePriceRuleWarrantySectionProps) {
  const {tenantCurrency} = useTenant();

  return (
    <PurchasePriceRuleFormSection
      title={i18n.t('page.settings.purchasePrice.ruleEditor.warranty.title')}
      description={i18n.t('page.settings.purchasePrice.ruleEditor.warranty.description')}
      data-testid={props.baseTestId('warrantySection')}
    >
      <FormField
        control={props.control}
        name="warrantyCost"
        type="currency"
        currency={tenantCurrency}
        label={i18n.t('page.settings.purchasePrice.ruleEditor.warranty.fixedAmount')}
        isRequired
        data-testid={props.baseTestId('warrantyCost')}
      />
    </PurchasePriceRuleFormSection>
  );
}
